export default {"src":"https://images-cdn-staging.curipod.com/d-1e801199/_next/static/media/feide-logo.aab537d8.ico","height":48,"width":48};